import query from './query';
import { keys } from './keys';
import Component from '../../components/Component';
import ListData from '../../components/ListData';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor(props) {
        super();
        if (props.isShowAuthors)
            this.query = query({
                offset: 0,
                domain: props.domain,
                limit: 10,
            });

        this.offsetStep = 100;
    }

    render() {
        const { t } = this.props;

        return (
            <ListData
                loading={this.state.loading}
                header={this.props.header ?? t('discover.overview.top_authors.header')}
                subheader={this.props.subheader ?? t('discover.overview.top_authors.subheader')}
                forceRun={this.forceRun}
                link={this.props.link}
                keys={keys}
                uniqKey="author"
                data={this.state.data}
                cardClassName={'list-data-full'}
                showError={!this.props.isShowAuthors}
                customErrorMessage={t('discover.overview.top_authors.customErrorMessage')}
            />
        );
    }
}

export default withTranslation()(Summary);
